import React, { useState } from 'react';

import { NumberInput } from './numberInput';
import { CodeInput } from './codeInput';

import '../css/modal.css'
import bootstrap ,{ Modal }from 'bootstrap'


export const ModalLayout=()=>{
  function submitForm() {
    const form = document.getElementById('myForm') as HTMLFormElement;
    if (form.checkValidity()) {
      // Perform form submission or other actions here
      form.reset();
      closeModal();
    } else {
      form.classList.add('was-validated');
    }
  }
  
  // Close modal function
  function closeModal() {
    const modal = document.getElementById('myModal');
    const bootstrapModal = new Modal(modal as HTMLElement);
    bootstrapModal.hide();
  }
  
  

  
  
    return(
      <div className="modal fade" id="myModal" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="d-flex justify-content-between p-3 my-2">
            <h5 className="modal-title" id="myModalLabel">reg code</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form id="myForm" className="needs-validation" noValidate>
              <NumberInput/>
              <CodeInput/>
            </form>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <button type="button" className="modalButton m-1" onClick={submitForm}><p>Submit</p></button>
            <a type="button" className="modal-close m-1" data-bs-dismiss="modal">Close</a>
          </div>
        </div>
      </div>
    </div>
    )
}